module.exports = __webpack_public_path__ + "static/media/gpp_good_24dp_E3E3E3.965107e3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gpp_good_24dp_E3E3E3.svg
// module id = 2441
// module chunks = 0